"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readOnlyRolePermissions = exports.opsManagerRolePermissions = exports.dataEntryRolePermissions = exports.adminRolePermissions = exports.Role = exports.getUsersRolePermissions = exports.Roles = void 0;
const permissions_type_1 = require("./permissions.type");
var Roles;
(function (Roles) {
    Roles["ADMIN"] = "admin";
    Roles["DATA_ENTRY"] = "data_entry";
    Roles["OPS_MANGER"] = "ops_manager";
    Roles["READ_ONLY"] = "read_only";
})(Roles = exports.Roles || (exports.Roles = {}));
const getUsersRolePermissions = (userRoles) => {
    const permissions = [];
    userRoles.forEach((role) => {
        switch (role.role) {
            case Roles.ADMIN:
                permissions.push(...exports.adminRolePermissions);
                break;
            case Roles.DATA_ENTRY:
                permissions.push(...exports.dataEntryRolePermissions);
                break;
            case Roles.OPS_MANGER:
                permissions.push(...exports.opsManagerRolePermissions);
                break;
            case Roles.READ_ONLY:
                permissions.push(...exports.readOnlyRolePermissions);
                break;
            default:
                break;
        }
    });
    return [...new Set(permissions)];
};
exports.getUsersRolePermissions = getUsersRolePermissions;
var Role;
(function (Role) {
    Role["ADMIN"] = "admin";
    Role["DATA_ENTRY"] = "data_entry";
    Role["OPS_MANGER"] = "ops_manager";
    Role["READ_ONLY"] = "read_only";
})(Role = exports.Role || (exports.Role = {}));
exports.adminRolePermissions = [...permissions_type_1.AllPermissions];
exports.dataEntryRolePermissions = [
    ...permissions_type_1.TruckPermissions,
    ...permissions_type_1.InvoicePermissions,
    ...permissions_type_1.DriverPermissions,
    ...permissions_type_1.CustomerPermissions,
    ...permissions_type_1.PayrollPermissions,
    'DRP_CREATE',
    'DRP_READ',
    'DRP_UPDATE',
    'DRP_READ_MANY',
    'CRP_CREATE',
    'CRP_READ',
    'CRP_UPDATE',
    'CRP_READ_MANY',
    'PAY_TYPES_READ',
    'PAY_TYPES_READ_MANY',
    'SERVICE_TYPES_READ',
    'SERVICE_TYPES_READ_MANY',
    'NONE',
];
exports.opsManagerRolePermissions = [
    'TRUCK_SEARCH',
    'TRUCK_READ',
    'TRUCK_READ_MANY',
    'INVOICE_READ',
    'INVOICE_READ_MANY',
    'PAY_TYPES_READ',
    'PAY_TYPES_READ_MANY',
    'SERVICE_TYPES_READ',
    'SERVICE_TYPES_READ_MANY',
    'NONE',
];
exports.readOnlyRolePermissions = [
    'USER_MANAGE_USER_READ',
    'USER_MANAGE_USER_READ_MANY',
    'DRIVER_READ',
    'DRIVER_READ_MANY',
    'TDM_READ',
    'TDM_READ_MANY',
    'CUSTOMER_READ',
    'CUSTOMER_READ_MANY',
    'TRUCK_READ',
    'TRUCK_READ_MANY',
    'INVOICE_READ',
    'INVOICE_READ_MANY',
    'DRP_READ',
    'DRP_READ_MANY',
    'CRP_READ',
    'PAY_TYPES_READ',
    'PAY_TYPES_READ_MANY',
    'SERVICE_TYPES_READ',
    'SERVICE_TYPES_READ_MANY',
    'PAYROLL_READ',
    'NONE',
];
//# sourceMappingURL=roles.config.js.map